const mesesCortos = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
const diasCortos = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sáb']

/**
 * table: '26 may 2025'
 */
const formatTable = (d) => {
  if (!d) return ''
  const date = new Date(d)
  if (isNaN(date)) return ''
  const day = String(date.getDate()).padStart(2, '0')
  const month = mesesCortos[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${month} ${year}`
}

/**
 *  input: 'lun, 26 may 2025'
 */
const formatInput = (d) => {
  if (!d) return ''
  const date = new Date(d)
  if (isNaN(date)) return ''
  const dayName = diasCortos[date.getDay()]
  const day = date.getDate()
  const month = mesesCortos[date.getMonth()]
  const year = date.getFullYear()
  return `${dayName}, ${day} ${month} ${year}`
}

const formatInputMonth = (d) => {
  if (!d) return ''
  const date = new Date(d)
  if (isNaN(date)) return ''
  const dayName = diasCortos[date.getDay()]
  const day = date.getDate()
  const month = mesesCortos[date.getMonth()]
  const year = date.getFullYear()
  return `${dayName}, ${day} ${month} ${year}`
}

/**
 * timestamp to date: '26 may 2025'
 */
const timestampToFormat = (time) => {
  const date = new Date(time)
  if (isNaN(date)) return ''
  return date.toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
}

const startTimestamp = (time) => {
  return new Date(
    time.getFullYear(),
    time.getMonth(),
    time.getDate(),
    0, 0, 0, 0
  ).getTime()
}

const endTimestamp = (time) => {
  return new Date(
    time.getFullYear(),
    time.getMonth(),
    time.getDate(),
    23, 59, 59, 999
  ).getTime()
}

const timetoApi = (date) => {
  const formattedDate = date.toISOString().split('T')[0]
  return formattedDate // Ejemplo: '2026-06-02'
}

export default {

  timestampToFormat,
  formatTable,
  formatInput,
  timetoApi,
  startTimestamp,
  endTimestamp,
  formatInputMonth

}
